export default __webpack_public_path__ + "media/music/d8fab511627360a9b8e8c4923d401cab.mp3";